import { create } from '@fhs/zustand';

import type { CommittedOrder } from '../../payment/payment-types';

type PaymentFlowState =
  | 'idle'
  | 'encrypting'
  | 'insertRequested'
  | 'serviceModeCheck'
  | 'validatingCart'
  | 'committing'
  | 'vaulting'
  | 'success'
  | 'error';

export interface PaymentErrorInfo {
  code: string;
  message: string;
  canRetry: boolean;
}

export interface PaymentRetryInfo {
  canRetry: boolean;
  retryFromStep: string;
  errorCode: string;
  errorMessage: string;
  failedStep?: string;
}

export interface PaymentFlowStore {
  currentState: PaymentFlowState;
  retryInfo: PaymentRetryInfo | null;
  rbiOrderId: string | null;
  pricedOrder: CommittedOrder | null;
  setRbiOrderId: (rbiOrderId: string | null) => void;
  setCurrentState: (state: PaymentFlowState) => void;
  setRetryInfo: (retryInfo: PaymentRetryInfo | null) => void;
  setPricedOrder: (order: CommittedOrder | null) => void;
  resetPaymentFlowStore: () => void;
}

const initialState = {
  currentState: 'idle' as PaymentFlowState,
  retryInfo: null,
  rbiOrderId: null,
  pricedOrder: null as CommittedOrder | null,
};

export const usePaymentFlowStore = create<PaymentFlowStore>((set, get) => ({
  ...initialState,
  setCurrentState: state => set({ currentState: state }),
  setRetryInfo: retryInfo => set({ retryInfo }),
  setRbiOrderId: rbiOrderId => set({ rbiOrderId }),
  setPricedOrder: order => set({ pricedOrder: order }),
  // Reset to initial state
  resetPaymentFlowStore: () => set({ ...initialState, rbiOrderId: get().rbiOrderId }),
}));
